<template>
  <ul :class="{ 'list-unstyled': true }">
    <li class="mb-2">
      <PhoneIcon class="me-2" />
      {{ EMAIL }}
    </li>

    <li class="mb-2 d-flex align-items-center">
      <MessageIcon class="me-2" />
      {{ CALL_CENTER_PHONE_NUMBER }}
    </li>

    <li class="me-4">
      <LocationIcon class="me-2 " />
      {{ $t('footer.address') }}
    </li>
  </ul>
</template>

<script>
import LocationIcon from '@/components/svg/LocationIcon';
import PhoneIcon from '@/components/svg/PhoneIcon';
import MessageIcon from '@/components/svg/MessageIcon';
import { CALL_CENTER_PHONE_NUMBER, EMAIL } from '@/utils/constants';

export default {
  name: 'TheContactsList',
  components: {
    LocationIcon,
    PhoneIcon,
    MessageIcon,
  },
  data: () => ({
    CALL_CENTER_PHONE_NUMBER,
    EMAIL,
  }),
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/mixins/_font.scss";

ul {
  li {
    @include font(20px, 500, 25px);
  }
}
</style>